<header>
  <div
    class="d-flex flex-row justify-content-between align-items-center py-3 text-sm mw-100"
    [class.container]="!isISAOpen"
    [ngClass]="{ 'container-100 pl-4 pr-4': isISAOpen }">
    <div class="mr-5">
      <img src="assets/svg/unity-logo-horz.svg" alt="Unity Logo" />
    </div>
    <div
      class="d-flex flex-row flex-sm-grow-1 justify-content-between align-items-center"
      *ngIf="loanDetails$ | async as headerData">
      <div class="text-end text-sm-start">
        Status
        <div class="text-primary font-semibold">
          {{ loanStatus }}
        </div>
      </div>
      <div
        class="estimated-monthly-payment-box"
        *ngIf="isShowEstimatedMonthlyPayment">
        <div class="estimated-monthly-copy">
          <span class="ribbon">Estimated</span> Monthly Payment
        </div>
        <div class="estimated-monthly-amount">
          {{ getMonthlyPaymentValue() | currency }}
        </div>
      </div>
      <div class="text-end d-none d-sm-block">
        {{ headerData.creditUnionName }}<br />
        <div class="font-semibold">Welcome! {{ headerData.loName }}</div>
      </div>
    </div>
  </div>
  <app-alert-container> </app-alert-container>
</header>
